import { createContext, useContext, useEffect, useState, type ReactNode } from 'react';

type TenantState = {
  selected: string[]; // empty = all
  setSelected: (next: string[]) => void;
  collapsed: boolean;
  setCollapsed: (next: boolean) => void;
};

const TenantContext = createContext<TenantState | null>(null);

const STORAGE_KEY = 'tomi.tenant.selected';

export function TenantProvider({ children }: { children: ReactNode }) {
  const [selected, setSelectedState] = useState<string[]>(() => {
    try {
      const v = localStorage.getItem(STORAGE_KEY);
      if (v) return JSON.parse(v) as string[];
    } catch {
      /* ignore */
    }
    return [];
  });
  const [collapsed, setCollapsed] = useState(false);

  useEffect(() => {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(selected));
    } catch {
      /* ignore */
    }
  }, [selected]);

  return (
    <TenantContext.Provider
      value={{ selected, setSelected: setSelectedState, collapsed, setCollapsed }}
    >
      {children}
    </TenantContext.Provider>
  );
}

export function useTenant(): TenantState {
  const ctx = useContext(TenantContext);
  if (!ctx) throw new Error('useTenant must be used within TenantProvider');
  return ctx;
}

export { TenantContext };
